var UserOperationStatus;
(function (UserOperationStatus) {
    UserOperationStatus["Pending"] = "PENDING";
    UserOperationStatus["PendingSign"] = "PENDING_SIGN";
    UserOperationStatus["Rejected"] = "REJECTED";
    UserOperationStatus["Success"] = "SUCCESS";
    UserOperationStatus["Fail"] = "FAIL";
    UserOperationStatus["NotExecuted"] = "NOT_EXECUTED";
})(UserOperationStatus || (UserOperationStatus = {}));
export {};
